const model = {
    authenticated: false,
    loggingIn: false,
    loggingInError: null,
    loggingOut: false,
    loggingOutError: null,
};

export default model;